import React, { useContext } from 'react';
import { StyledMobileMenuPanel } from './Navbar.styles.js';
import { NavbarContext } from './NavbarContext.js';
import { NavbarHelixIcon } from './NavbarHelixIcon.js';
import ApplicationSwitcherAppInstanceDropdown from './ApplicationSwitcherAppInstanceDropdown.js';
import { strings } from './strings.js';
/* eslint-disable max-len */

var ApplicationSwitcherMobilePanel = function ApplicationSwitcherMobilePanel(_ref) {
  var applicationName = _ref.applicationName;

  var _useContext = useContext(NavbarContext),
      isDark = _useContext.isDark,
      appSwitcherItems = _useContext.appSwitcherItems,
      showMobileApplicationSwitcher = _useContext.showMobileApplicationSwitcher,
      setShowMobileApplicationSwitcher = _useContext.setShowMobileApplicationSwitcher,
      setShowMobileMenu = _useContext.setShowMobileMenu,
      setShowMobileNotifications = _useContext.setShowMobileNotifications,
      appSwitcherLinkWrapper = _useContext.appSwitcherLinkWrapper,
      launchpadUrl = _useContext.launchpadUrl;

  var appSectionLinkItem = function appSectionLinkItem(sectionItem) {
    return React.createElement("div", {
      className: 'helix-unified-nav__app-switcher-panel-section-item-content-wrapper'
    }, sectionItem.icon && React.createElement("div", {
      className: 'helix-unified-nav__app-switcher-panel-item-icon'
    }, typeof sectionItem.icon === 'string' ? React.createElement(NavbarHelixIcon, {
      iconName: sectionItem.icon
    }) : sectionItem.icon), React.createElement("div", {
      className: 'helix-unified-nav__app-switcher-panel-item-content-container'
    }, React.createElement("div", {
      className: 'helix-unified-nav__app-switcher-panel-item-content'
    }, sectionItem.label && React.createElement("div", {
      className: 'helix-unified-nav__app-switcher-panel-item-label'
    }, sectionItem.label), sectionItem.description && React.createElement("div", {
      className: 'helix-unified-nav__app-switcher-panel-item-description'
    }, sectionItem.description), sectionItem.appInstances && React.createElement(React.Fragment, null, React.createElement(ApplicationSwitcherAppInstanceDropdown, {
      item: sectionItem
    }))), sectionItem.notActive && React.createElement("span", {
      className: 'helix-unified-nav__app-switcher-panel-item-not-active'
    }, "Try it free")));
  };

  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: 'helix-unified-nav__application-name'
  }, React.createElement("button", {
    className: "helix-unified-nav__navigation-item ".concat(showMobileApplicationSwitcher ? 'active' : ''),
    onClick: function onClick() {
      setShowMobileMenu(false);
      setShowMobileNotifications(false);
      setShowMobileApplicationSwitcher(!showMobileApplicationSwitcher);
    },
    style: {
      position: 'relative'
    }
  }, React.createElement("span", {
    className: 'helix-unified-nav__application-switcher-product-name'
  }, applicationName), React.createElement(NavbarHelixIcon, {
    iconName: 'dropdown_open'
  }))), showMobileApplicationSwitcher && React.createElement(StyledMobileMenuPanel, {
    className: 'helix-unified-nav__app-switcher-panel',
    isDark: isDark
  }, appSwitcherItems.map(function (section, sectionIndex) {
    return React.createElement("div", {
      key: "app-switch-mobile-section-".concat(sectionIndex)
    }, section.sectionItems && React.createElement("div", {
      className: 'helix-unified-nav__app-switcher-panel-section'
    }, section.sectionName && React.createElement("div", {
      className: 'helix-unified-nav__app-switcher-panel-section-name'
    }, section.sectionName), section.sectionItems.length > 0 && section.sectionItems.map(function (sectionItem, sectionItemIndex) {
      return sectionItem.url ? React.createElement(React.Fragment, {
        key: "app-switch-mobile-section-item-".concat(sectionItemIndex)
      }, appSwitcherLinkWrapper ? React.createElement("div", {
        className: 'helix-unified-nav__app-switcher-panel-section-item'
      }, appSwitcherLinkWrapper({
        item: sectionItem,
        props: {
          children: appSectionLinkItem(sectionItem)
        }
      })) : React.createElement("a", {
        key: "app-switch-mobile-section-item-".concat(sectionItemIndex),
        href: sectionItem.url,
        target: sectionItem.target ? sectionItem.target : '_self',
        className: 'helix-unified-nav__app-switcher-panel-section-item'
      }, appSectionLinkItem(sectionItem))) : React.createElement("button", {
        onClick: function onClick() {
          return sectionItem.onClick && sectionItem.onClick();
        },
        key: "app-switch-mobile-section-item-".concat(sectionItemIndex),
        disabled: sectionItem.disabled,
        className: "helix-unified-nav__app-switcher-panel-section-item ".concat(sectionItem.notActive ? 'not-active' : '', " ").concat(sectionItem.selected ? 'selected-item' : '')
      }, appSectionLinkItem(sectionItem));
    })));
  }), launchpadUrl && React.createElement(React.Fragment, null, React.createElement("hr", {
    className: 'helix-unified-navbar__mobile-menu-divider'
  }), React.createElement("div", {
    className: 'helix-unified-nav__app-switcher-panel-section'
  }, React.createElement("a", {
    href: launchpadUrl,
    className: 'helix-unified-nav__app-switcher-panel-section-item'
  }, React.createElement("div", {
    className: 'helix-unified-nav__app-switcher-panel-section-item-content-wrapper'
  }, React.createElement("div", {
    className: 'helix-unified-nav__app-switcher-panel-item-icon'
  }, React.createElement(NavbarHelixIcon, {
    iconName: 'app_grid'
  })), React.createElement("div", {
    className: 'helix-unified-nav__app-switcher-panel-item-content-container'
  }, React.createElement("div", {
    className: 'helix-unified-nav__app-switcher-panel-item-content'
  }, React.createElement("div", {
    className: 'helix-unified-nav__app-switcher-panel-item-label'
  }, strings.manageAppsAndSettings)))))))));
};

export { ApplicationSwitcherMobilePanel as default };